export const editableStyle: React.CSSProperties = {
    cursor: "pointer",
};
